import React, { useEffect } from 'react';
import './AccHelper.css';
import YunSection from '../YunSection/YunSection';
import { compareVersions, } from '../../../utils/index';
import {  cppGetAppInfo, } from '../../../api/cpp';
import { runAccHelper, closeAccHelper, showAccHelper } from './tools';
const appInfo = cppGetAppInfo();
// 3.9.8以上版本
const isNewVersion398 = compareVersions(appInfo && appInfo.version, "3.9.8");

const AccHelper = function(props) {
    const { AccHelperValue, isAccHelper } = props
    useEffect(() => {
        if (isAccHelper && isNewVersion398) {
            console.log("开启伴奏助手")
            runAccHelper()
        } else if (!isAccHelper && isNewVersion398) {
            console.log("关闭伴奏助手")
            closeAccHelper()
        }
    }, [isAccHelper])
    if (!isAccHelper) {
        return null
    }
    return (
        <div className="AccHelper YunComponent">
            <YunSection width="200" height="33">
                { isNewVersion398 ? (
                    <div className="AccHelperWrapper">
                        <div className="YunBtn" onClick={showAccHelper}>伴奏助手</div>
                        <div className="AccHelperSharpFlatValue">
                            <div><span className="MainColor">伴奏</span>升降调：</div>
                            <div className="Val">{AccHelperValue}</div>
                        </div>
                    </div>
                ) : (
                    <div className="AccHelperTipWrapper">
                        <div className="AccHelperTip">
                            使用<span className="MainColor">伴奏助手</span>需升级电音助手
                        </div>
                    </div>
                ) }
            </YunSection>
        </div>
    )
}

export default AccHelper;
